import type { AgentDeploymentAttribute as AgentDeploymentAttributeModel } from '@/adapters/catalogv1.g';

export function extractAgentDeploymentAttribute(
  model: AgentDeploymentAttributeModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    deploymentRef: model.deployment_ref ?? '',
    attributeRef: model.attribute_ref ?? '',
    value: model.value ?? '',
    type: model.type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentDeploymentAttribute = ReturnType<
  typeof extractAgentDeploymentAttribute
>;
